module.exports = __webpack_public_path__ + "media/application/images/svgs/x-logo-0c9462a79f736453eac5bf7cbb756875.svg";